/* Brave Bottoms: "Remove" / "Add it back" on the free gift rows in the cart drawer (snippets/bb-cart-gifts.liquid).
   Saves a cart attribute such as "Free guide" = "Removed" (blank clears it). The order emails skip a removed gift. */
(function () {
  if (window.bbCartGifts) return;
  window.bbCartGifts = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-gift]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-bb-gift-row]');
    var removing = btn.getAttribute('data-bb-gift-action') === 'remove';
    var attrs = {};
    attrs[btn.getAttribute('data-bb-gift')] = removing ? 'Removed' : '';
    btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        if (!row) return;
        if (removing) row.setAttribute('data-off', ''); else row.removeAttribute('data-off');
        var next = row.querySelector('[data-bb-gift-action="' + (removing ? 'add' : 'remove') + '"]');
        if (next) next.focus();
      })
      .catch(function () {})
      .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();

/* Brave Bottoms: cart urgency line (snippets/bb-cart-urgency.liquid).
   Rolling per-shopper countdown (restarts when it runs out) plus the real ship date in business days. */
(function () {
  if (window.bbCartUrgency) return;
  window.bbCartUrgency = true;
  var KEY = 'bb-cu-end';
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dkey(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function shipText(el) {
    var days = Math.max(0, parseInt(el.getAttribute('data-days') || '0', 10));
    var skip = (el.getAttribute('data-skip') || '').split(',').map(function (s) { return s.trim(); });
    var open = function (d) { return d.getDay() !== 0 && d.getDay() !== 6 && skip.indexOf(dkey(d)) === -1; };
    var d = new Date(); d.setHours(12, 0, 0, 0);
    var g = 0;
    if (days === 0) { while (!open(d) && g++ < 60) d.setDate(d.getDate() + 1); }
    else { var left = days; while (left > 0 && g++ < 90) { d.setDate(d.getDate() + 1); if (open(d)) left -= 1; } }
    var today = new Date(); today.setHours(12, 0, 0, 0);
    var diff = Math.round((d - today) / 86400000);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    return 'by ' + new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(d);
  }
  function endTime(mins) {
    var now = Date.now(), end = 0;
    try { end = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    if (!end || end <= now || end - now > mins * 60000) {
      end = now + mins * 60000;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tick() {
    var els = document.querySelectorAll('[data-bb-urgency]');
    if (!els.length) return;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var mins = parseInt(el.getAttribute('data-mins') || '26', 10);
      var left = Math.max(0, endTime(mins) - Date.now());
      var s = Math.floor(left / 1000);
      var t = el.querySelector('[data-bb-cu-time]');
      var txt = Math.floor(s / 60) + ':' + pad(s % 60);
      if (t && t.textContent !== txt) t.textContent = txt;
      var dEl = el.querySelector('[data-bb-cu-date]');
      if (dEl && !dEl.getAttribute('data-done')) { dEl.textContent = shipText(el); dEl.setAttribute('data-done', '1'); }
    }
  }
  setInterval(tick, 1000);
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; tick(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();
